// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"1456942b","637":"401e733e","910":"1456942b"}[chunkId] + ".chunk.css";
};